import { DatePipe } from '@angular/common';

import { convertSecondsToPeriodAndUnit } from 'core/date/seconds-to-period-and-unit';

import { IRangeOrRelativeDateModel } from './IRangeOrRelativeDateModel';

const asDateString = (input: string | Date) => {
  if (input == null) {
    return null;
  }
  const transformed = new DatePipe('en-us').transform(input, 'MM/dd/yyyy');;
  return transformed;
};

export const makeDateRangeText = (
  input: IRangeOrRelativeDateModel
) => {
  const { startDate, endDate, relativeOffset } = input;
  const start = asDateString(startDate);
  const end = asDateString(endDate);

  if (start && end) {
    return `between: ${start} and ${end}`;
  }
  if (start && !end) {
    return `after: ${start}`;
  }
  if (end && !start) {
    return `before: ${end}`;
  }

  if (relativeOffset) {
    const { period, units } = convertSecondsToPeriodAndUnit(relativeOffset);
    const pluralizedPeriod = Math.abs(units) === 1 ? period : `${period}s`;
    return `In the previous ${Math.abs(units)} ${pluralizedPeriod}`;
  }
};


export const makeDateRangePillText = (startDate: string | Date, endDate: string | Date, relativeOffset?: number) => {
  const text = makeDateRangeText({startDate, endDate, relativeOffset});
  if (text) {
    return `<span class="smaller d-block">${text}</span>`;
  }
  return '';
};
